import { useMemo } from 'react';
import ReactGA from 'react-ga4';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { ampli } from '../../../ampli';
import { newProductPageInfo, pageInfo } from '../../../constants/pageInfo/pageInfo.constant';

export interface GoToListPageButtonProps {
  renderedIn: 'home' | 'pdp' | 'odp' | 'idp' | 'mpdp' | 'ndp';
  itemType: 'pluva' | 'partner' | 'open-market' | 'info' | 'new-product';
  height?: number;
}

export const GoToListPageButton = ({ renderedIn, itemType, height = 386 }: GoToListPageButtonProps) => {
  const navigate = useNavigate();

  const landingPagePath = useMemo<string>(() => {
    switch (itemType) {
      case 'info':
        return pageInfo.infoListPage.path;
      case 'pluva':
        return `${pageInfo.productListPage.path}?category=PLUVA&status=ONSALE&brand=&sort=common`;
      case 'partner':
        return `${pageInfo.productListPage.path}?category=PARTNER&status=ONSALE&brand=&sort=common`;
      case 'new-product':
        return newProductPageInfo.listPage.path;
      default:
        return pageInfo.openMarketListPage.path;
    }
  }, [itemType]);

  const buttonName = useMemo<string>(() => {
    switch (itemType) {
      case 'info':
        return '정보';
      case 'pluva':
        return '플루바 매물';
      case 'partner':
        return '파트너 매물';
      case 'new-product':
        return '신품관';
      default:
        return '직거래 매물';
    }
  }, [itemType]);

  const handleMoreButtonClick = () => {
    ampli.pvmClickMoreProductButton({
      page_type: renderedIn,
      category: itemType,
    });
    ReactGA.event('pvm_click_more_product_button', {
      action: 'click',
      category: itemType,
      page_type: renderedIn,
    });
    navigate(landingPagePath, { replace: true });
  };

  return (
    <Container onClick={handleMoreButtonClick} height={height}>
      <IconBackground>
        <svg xmlns={'http://www.w3.org/2000/svg'} width={'20'} height={'21'} viewBox={'0 0 20 21'} fill={'none'}>
          <path
            d={
              'M3.04712 9.552H14.6881L10.3291 5.047C9.94512 4.65 9.95512 4.017 10.3521 3.633C10.7481 3.249 11.3821 3.259 11.7661 3.656L17.7661 9.856C18.1411 10.244 18.1411 10.859 17.7661 11.247L11.7661 17.447C11.5701 17.65 11.3081 17.752 11.0471 17.752C10.7971 17.752 10.5461 17.658 10.3521 17.471C9.95512 17.087 9.94512 16.453 10.3291 16.057L14.6881 11.552H3.04712C2.49412 11.552 2.04712 11.105 2.04712 10.552C2.04712 9.999 2.49412 9.552 3.04712 9.552Z'
            }
            fill={'#B1B3C0'}
          />
        </svg>
      </IconBackground>
      <Text>{`${buttonName} 전체보기`}</Text>
    </Container>
  );
};

const Container = styled.div<{ height: number }>`
  width: 150px;
  min-width: 150px;
  height: ${(props) => props.height && `${props.height}px`};

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  padding: 10px;

  gap: 10px;

  border-radius: var(--radius-medium, 8px);
  background: var(--light-scheme-monochrome-grey-10, #f2f2f7);
`;

const IconBackground = styled.div`
  display: flex;
  width: 40px;
  height: 40px;
  justify-content: center;
  align-items: center;
  gap: 10px;

  border-radius: var(--radius-round, 80px);
  background: var(--light-scheme-monochrome-grey-20, #e4e4ed);
`;

const Text = styled.span`
  color: var(--light-scheme-monochrome-grey-100, #858894);
  text-align: center;

  /* Body/Medium/m-medium */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%; /* 21px */
`;
